
var userSingleton;

import User from 'zoomforth_zf/models/user.js';

import permissionDefsStore from './permission-defs.js';

const init =  function(userData) {
  if (!userData) {
    throw new Error('`init` of user singleton must include user data');
  }
  userSingleton = User.init(userData, { permissionDefs:permissionDefsStore.get() });
};
const get = function() {
  if (!userSingleton) {
    throw new Error('You must call `init` on `user` appglobal before calling `get`');
  }
  return userSingleton;
};

export { init, get };

export default { init, get };